import Vue from 'vue';
import axios from 'axios';
import { Modal } from 'view-design';
import router from '@/router/router'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.API_ROOT, // api的base_url
  timeout: 35000 // 请求超时时间
})


service.interceptors.request.use(config => {
  setHttpBaseUrl(config);
  return config;
}, err => {
  return Promise.reject(err)
})

// axios拦截响应
service.interceptors.response.use(
  response => {
    return response;
  }, err => {
    if (err.response.data.code === 402) { // token过期
      Modal.confirm({
        title: "提示",
        content: "会话已过期，请重新登录",
        onOk() {
          sessionStorage.removeItem("token")
          router.replace('/');
        }
      })
    }

    return Promise.reject(err)
})



export default {
  get(url, params) {
    return service.get(url, params);
  },
  post(url, params) {
    return service.post(url, params);
  },
  postQs(url, params) {
    //将参数以对象形式序列化成字符串拼接形式
    var qs = require('qs');
    //  addToken(params);
    return service.post(url, qs.stringify(params));
  },
  formPost(url, params) {
    return service.post(url, setHttpParamsForPost(params));
  },
}

function setHttpBaseUrl(config) {
  if (process.env.NODE_ENV == "production") {
    if (config.url.indexOf("api") == 0) {
      config.headers['Content-Type'] = 'application/json';
      config.headers['token'] = window.sessionStorage.getItem("token");
      // config.url = config.url.replace(/api/g, '', "'$1'");
    }
  } else {
    if (config.url.indexOf("api") == 0) {
      config.headers['Content-Type'] = 'application/json';
      config.headers['token'] = window.sessionStorage.getItem("token");
      // config.url = config.url.replace(/api/g, '', "'$1'");
    }
  }
}

function setHttpParamsForPost(data) {
  var params = new FormData();
  if (data) {
    for (var name in data) {
      params.append(name, data[name]);
    }
  }
  return params;
}

Vue.prototype.$axios = service



// WEBPACK FOOTER //
// ./src/server/server.js